import {
  CHAT_WORKSPACE_PATH,
  primaryAppPath,
} from "../../utils/appNavigation";

export const CLASSIC_WORKSPACE_REMINDER_KEY =
  "incite:classic-workspace-reminder-dismissed-on:v2";

export const localCalendarDay = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const millisecondsUntilNextLocalDay = (date = new Date()) => {
  const nextDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() + 1,
  );
  return Math.max(1_000, nextDay.getTime() - date.getTime());
};

export const shouldShowClassicWorkspaceReminder = ({
  dismissedOn = null,
  primaryPath = primaryAppPath(),
  today = localCalendarDay(),
} = {}) =>
  primaryPath === CHAT_WORKSPACE_PATH && dismissedOn !== today;
